import normalize from "json-api-normalizer"
import customAxios from "./customAxios"

export const getNotificationSettings = (baseUrl) => {
  const path = `${baseUrl}/notification_settings`

  return customAxios.get(path)
    .then(({ data, status }) => ({ response: normalize(data, { endpoint: "meta" }), status }))
    .catch(error => ({ error }))
}

export const getNotificationSetting = (baseUrl, id) => {
  const path = `${baseUrl}/notification_settings/${id}`

  return customAxios.get(path)
    .then(({ data, status }) => ({
      response: {
        ...normalize(data, { endpoint: "meta" }),
        meta: data.meta || {}
      },
      status
    }))
    .catch(error => ({ error }))
}

export const updateNotificationSetting = (baseUrl, id, attributes) => {
  const path = `${baseUrl}/notification_settings/${id}`
  const payload = {
    notification_setting: {
      title: attributes.title,
      body: attributes.body,
      fallback_user_id: attributes.fallbackUserId,
      recipient_user_ids: attributes.recipientUserIds,
      recipient_groups: (attributes.recipientGroups || []).map(group => ({
        kind: group.kind,
        team_id: group.teamId,
        team_role: group.teamRole,
        system_role: group.systemRole
      }))
    }
  }

  return customAxios.put(path, payload)
    .then(({ data, status }) => ({ response: normalize(data), status }))
    .catch(error => ({ error }))
}
